import { Record, Iterable } from 'immutable';
import { Fields } from '@engoo/view-model';

export const Blame = Record({
  nodes: undefined, // List of BlameNode
}, 'Blame');

export const BlameNode = Record({
  [Fields.TYPE]: undefined,
  [Fields.ID]:   undefined,
}, 'BlameNode');

const parseNodes = (nodesMap) =>
  Iterable(nodesMap).map((nodeMap) =>
    BlameNode({
      [Fields.TYPE]: nodeMap.get(Fields.TYPE),
      [Fields.ID]:   nodeMap.get(Fields.ID),
    }),
  ).toList();

const parseMeta = (metaMap) =>
  Blame({
    nodes: metaMap.has('nodes') && parseNodes(metaMap.get('nodes')),
  });

const parseValidationMetadata = (applicationError) =>
  applicationError.update('meta', parseMeta);

export const parseValidationErrors = (applicationErrors) =>
  Iterable(applicationErrors).map(parseValidationMetadata).toList();
